import React, { useEffect } from "react";
import ApexCharts from "apexcharts";
import { useFilter } from "../../../../FilterContext";
import jsonData from "../../../../current-survey-numeric.json";
import "./engagement-summary.css"; // Import the prefixed CSS file

const WorkContextChart = () => {
  const { filterCriteria } = useFilter();

  const calculateAverageScores = (data, categories) => {
    const scores = Object.keys(categories).reduce((acc, key) => {
      // Flatten all valid scores for each category
      const categoryScores = categories[key].flatMap((question) =>
        data
          .map((item) => item[question])
          .filter(
            (score) =>
              score !== undefined && score !== null && score >= 1 && score <= 5
          )
      );

      // Calculate direct average for the category
      acc[key] = categoryScores.length
        ? categoryScores.reduce((a, b) => a + b, 0) / categoryScores.length
        : 0;

      acc[key] = parseFloat(acc[key].toFixed(1)); // Round to one decimal place
      return acc;
    }, {});

    return scores;
  };

  useEffect(() => {
    const categories = {
      "Work Context: Safety": ["MQ0190", "MQ0141", "MQ0343"],
      "Work Context: Compensation": ["MQ0088", "MQ0090", "MQ0091"],
      "Work Context: Leadership": ["MQ0086", "MQ0034", "MQ0041"],
      "Work Context: Communication": ["MQ0194", "MQ0321", "MQ0058"],
      "Work Context: Supervision": ["MQ0056", "MQ0057", "MQ0038"],
    };

    const filteredData = jsonData.filter((item) => {
      return Object.keys(filterCriteria).every((key) => {
        const criteria = filterCriteria[key];
        if (Array.isArray(criteria)) {
          return criteria.length === 0 || criteria.includes(item[key]);
        }
        return criteria === "" || item[key] === criteria;
      });
    });

    const scores = calculateAverageScores(filteredData, categories);

    const options = {
      chart: {
        type: "bar",
        height: "100%", // Fill height
        width: "100%", // Fill width
      },
      grid: {
        padding: {
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
        },
      },
      legend: {
        show: false,
      },
      title: {
        text: "Average Scores by Work Context",
        align: "Center",
        style: {
          fontSize: "20px",
          fontWeight: "bold",
          color: "#263238",
        },
      },
      plotOptions: {
        bar: {
          borderRadius: 1,
          horizontal: true,
          dataLabels: {
            position: "top",
          },
          barHeight: "90%",
        },
      },
      dataLabels: {
        enabled: true,
        formatter: (val) => val.toFixed(1),
        offsetX: 35,
        style: {
          colors: ["#000"],
        },
      },
      series: [
        {
          name: "Avg Score",
          data: [
            scores["Work Context: Communication"],
            scores["Work Context: Compensation"],
            scores["Work Context: Leadership"],
            scores["Work Context: Safety"],
            scores["Work Context: Supervision"],
          ],
        },
      ],
      colors: ["#ff8c00"],
      xaxis: {
        max: 5.0,
        categories: [
          "Communication",
          "Compensation",
          "Leadership",
          "Safety",
          "Supervision",
        ],
      },
      yaxis: {
        labels: {
          show: true,
          minWidth: 120,
        },
      },
    };

    const chart = new ApexCharts(document.querySelector("#wc-bar"), options);
    chart.render();

    return () => {
      chart.destroy();
    };
  }, [filterCriteria]);

  return (
    <div className="engagement-summary-chart-container">
      <div id="wc-bar"></div>
    </div>
  );
};

export default WorkContextChart;
